import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// Custom
import { simcardDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const SimcardInformationItem = ({ simcard, light }) => {
  if (simcard) {
    const { color } = mSimcard.status(simcard);

    return (
      <InformationItem
        light={light}
        icon={mSimcard.icon}
        iconColor={color}
        label={<LocalizedMessage id="info.simcardWithStatus" values={{ status: simcard.status }} />}
        value={simcard.number || <LocalizedMessage id="info.simcardNoNumber" />}
      />
    );
  }
  return (
    <InformationItem
      light={light}
      icon={mSimcard.icon}
      label=""
      value={<LocalizedMessage id="info.noSimcard" />}
    />
  );
};

SimcardInformationItem.propTypes = {
  simcard: simcardDataShape,
  light: PropTypes.bool,
};

SimcardInformationItem.defaultProps = {
  simcard: null,
  light: false,
};

module.exports = SimcardInformationItem;



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/main/SimcardInformationItem.js